import React from "react";
import Label from "components/general/Label";
import DateTime from "components/presentation/DateTime";
import SportCode from "components/common/SportCode";
import { getDateTimeFormat } from "helpers/utils";


export default function ScheduleDataTime({ data, format, formatDateAddText }) {
    const hideStart = data?.hideStartDate
    const hideEnd = data?.hideEndDate === false ? false : true
    const startText = data?.startText
    const formatDefault = format ? getDateTimeFormat(format) : getDateTimeFormat('HourMinute');
    const formatDateAddTextLocal = getDateTimeFormat(formatDateAddText);
    const formatDate = getDateTimeFormat('DayMonthShort');

    let sText
    if (startText) {
        const startTextSportCode = <SportCode code={startText} entity="@StartText" notFound={startText} />
        if (formatDateAddTextLocal) {
            sText = <><DateTime format={formatDateAddTextLocal} datetime={data?.startDate} /> ,  {startTextSportCode !== undefined ? startTextSportCode : startText} </>
        } else {
            sText = startTextSportCode !== undefined ? startTextSportCode : startText
        }
    }
    const out = !hideStart
        ? <DateTime format={formatDefault} datetime={data?.startDate} />
        : !hideEnd
            ? (
                <>
                    <Label data="LabelFinishOn" />&nbsp;
                    <DateTime format={formatDate} datetime={data?.endDate} />
                </>
            )
            : startText
                ? sText
                : ''
    return (<div className='text-wrap'>{out}</div>)

}